import React, {Component} from 'react'
import styled, { css } from 'styled-components'
import { rgba } from 'polished'
import { truncate } from 'lodash'
import { navigateTo } from "gatsby-link"

import { media } from '../../styles/utils'
import { bgImage, hoverState, bgIcon } from '../../styles/global'

// import search from '../../assets/icons/search.svg'

class SearchInput extends Component {

	state = {
		query: null
	}
	
	componentWillMount = () => {
		const { initialValue } = this.props;
		
		if (initialValue) { 
			this.setState({
				query: initialValue
			})
		}
	}
	
	onChange = (event) => {
		this.setState({query: event.target.value});
	}
	
	handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			this.props.callback(this.state.query)
		}
	}

    render() {
		const { style, props, value } = this.props;
		const { query } = this.state;

        return (
            <Search>
                <SearchWrapper>
                    <Input
                        type="text"
                        placeholder={'Type your search'}
						onKeyPress={this.handleKeyPress}
						onChange={this.onChange}
						value={query}
                    />
                </SearchWrapper>
            </Search>
        )
    }
}

const Search = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
`;

const SearchWrapper = styled.div`
	justify-content: center;
	align-items: center;
	position: relative;
	flex: 0 1 565px;
	margin-bottom: 24px;
`;

const Input = styled.input`
	appearance: none;
	border: 0;
	
	width: 100%;
	height: 50px;
	text-align: center;
	border: solid 2px black;
	box-shadow: 0 0 0 0 transparent;

	padding: 0 27px;
	box-sizing: border-box;
	background: white;
	z-index: 2;
	position: relative;

	${media.phone`
		height: 52px;
	`}

	&, &::placeholder {
		font-family: 'Dot Stick';
		font-size: 10px;
	}

	&::placeholder {
		color: rgba(0,0,0,0.30);
	}

	&:focus {
		outline: none;
	}

`;


export default SearchInput;


// WEBPACK FOOTER //
// ./src/components/SearchInput/SearchInput.js